import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Brand } from '../common/Brand';
import '../../pages/Legal.css';

interface LegalPageProps {
  kicker: string;
  title: string;
  effectiveDate: string;
  children: React.ReactNode;
}

/** Shared chrome for the Privacy Policy / Terms pages (Obsidian & Champagne). */
export const LegalPage: React.FC<LegalPageProps> = ({ kicker, title, effectiveDate, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    // The page <title> is owned by <Seo/> (react-helmet-async); don't override it.
  }, [title]);

  return (
    <div className="legal">
      <header className="l-head">
        <div className="l-head-in">
          <Link className="l-back" to="/">← Back to LACloud</Link>
          <Link to="/" aria-label="LACloud home"><Brand variant="lockup" height={26} /></Link>
        </div>
      </header>

      <div className="wrap">
        <div className="l-title">
          <div className="l-kicker">{kicker}</div>
          <h1>{title}</h1>
          <div className="l-meta">Effective {effectiveDate}</div>
        </div>
        <article className="l-body">{children}</article>
      </div>

      <footer className="l-foot">
        © 2026 Chrono Travel LLC · LACloud
        <div style={{ marginTop: 8 }}>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
          <Link to="/support">Support</Link>
          <Link to="/">Home</Link>
        </div>
      </footer>
    </div>
  );
};

export default LegalPage;
